/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import { Row, Col, Button, Form } from "react-bootstrap";
import FadeIn from "../../common/FadeIn";

const CreateClassForm = (props) => {
  //Grab the relevant VenueID and Name from props
  const venueID = props.venueID;
  const VenueName = props.VenueName;
  //Manage States
  const [Day, setDay] = useState("");
  const [StartTime, setStartTime] = useState("");
  const [FinishTime, setFinishTime] = useState("");
  const [MaxLearners, setMaxLearners] = useState("");
  const [Price, setPrice] = useState("");
  const [UpperAgeString, setUpperAgeString] = useState("");
  const [LowerAgeString, setLowerAgeString] = useState("");
  const [ShortDescription, setShortDescription] = useState("");
  const [LessonType, setLessonType] = useState("");
  const [SelectedClassType, setSelectedClassType] = useState("");
  const [GradingList, setGradingList] = useState([]);
  const [isHiddenFromSchedule, setIsHiddenFromSchedule] = useState("");
  const [StartDate, setStartDate] = useState("");
  const [Prorate, setProrate] = useState("");
  const [monthStartBilling, setMonthStartBilling] = useState("");
  // Handle Click State
  const [submitClicked, setSubmitClicked] = useState(false);

  //Get Class Types from Props
  const classTypes = props.classTypes;

  // Populate the Class Type Data
  const onClassTypeChange = async (e) => {
    const selectedID = e.target.value;
    setSelectedClassType(selectedID);
    //Filter to the Class Types specific info
    const selectedTypeData = await classTypes.find((x) => x._id === selectedID);
    //Set the relevant info
    setUpperAgeString(selectedTypeData.UpperAgeString);
    setLowerAgeString(selectedTypeData.LowerAgeString);
    setShortDescription(selectedTypeData.ShortDescription);
    setLessonType(selectedTypeData.Type);
    setGradingList(selectedTypeData.GradingList);
  };

  const submitNewClass = async (e) => {
    e.preventDefault();
    //Set Submit Click
    setSubmitClicked(true);
    //Build the Data
    const data = {
      classData: {
        LessonType,
        ShortDescription,
        LowerAgeString,
        UpperAgeString,
        GradingList,
        Day,
        StartTime,
        FinishTime,
        MaxLearners,
        Price,
        isHiddenFromSchedule,
        StartDate,
        Prorate,
        monthStartBilling,
      },
      venueID,
      VenueName,
    };
    // Make the API Request
    const classCreateRequest = await axios.post(
      `/api/admin/manage_prices/create_stripe_product/`,
      data,
      {
        withCredentials: true,
      }
    );
    // Handle Success and failure.
    if (classCreateRequest.status === 200) {
      props.scrollSmoothHandler();
      setSubmitClicked(false);
      props.fetchNewData();
      return props.setSuccessMessage("Class was successfully created.");
    } else {
      props.scrollSmoothHandler();
      setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Row className='mt-4'>
      <FadeIn delay={250} duration={450}>
        <Form onSubmit={submitNewClass} className='p-4 shadow'>
        <h4 className='text-center mb-3'>Create Regular Booking</h4>
          <Row>
            <Col sm='3' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='SelectCustomForm'>
                <Form.Label>Choose Class Type</Form.Label>
                <Form.Control
                  as='select'
                  value={SelectedClassType}
                  onChange={onClassTypeChange}
                  required
                  custom
                  className='border'
                >
                  <option value='' disabled defaultValue>
                    Select your option
                  </option>
                  {classTypes.map((ClassType) => (
                    <option key={ClassType._id} value={ClassType._id}>
                      {ClassType.Type}
                    </option>
                  ))}
                </Form.Control>
                <Form.Text className='text-muted'>
                  The type of lesson this is - if none, go set them up in Class Types.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm='3' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='SelectCustomFormHidden'>
                <Form.Label>Public/Hidden</Form.Label>
                <Form.Control
                  as='select'
                  value={isHiddenFromSchedule}
                  onChange={(e) => setIsHiddenFromSchedule(e.target.value)}
                  required
                  custom
                  className='border'
                >
                  <option value='' disabled defaultValue>
                    Select your option
                  </option>
                  <option value='public'>On Public Schedule</option>
                  <option value='hidden'>Hidden From Schedule</option>
                </Form.Control>
                <Form.Text className='text-muted'>
                  Hidden classes do not show on the public schedule but can be linked.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm='3' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='SelectCustomFormHidden'>
                <Form.Label>Proration</Form.Label>
                <Form.Control
                  as='select'
                  value={Prorate}
                  onChange={(e) => setProrate(e.target.value)}
                  required
                  custom
                  className='border'
                >
                  <option value='' disabled defaultValue>
                    Select your option
                  </option>
                  <option value={true}>On</option>
                  <option value={false}>Off</option>
                </Form.Control>
                <Form.Text className='text-muted'>
                  Automatic covering payments. Consult signaclass docs for full explanation.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm='3' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='SelectCustomFormHidden'>
                <Form.Label>Month Start Billing</Form.Label>
                <Form.Control
                  as='select'
                  value={monthStartBilling}
                  onChange={(e) => setMonthStartBilling(e.target.value)}
                  required
                  custom
                  className='border'
                >
                  <option value='' disabled defaultValue>
                    Select your option
                  </option>
                  <option value={true}>On</option>
                  <option value={false}>Off</option>
                </Form.Control>
                <Form.Text className='text-muted'>
                  Modifies proration behaviour. Consult signaclass docs for full explanation.
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm='4' className='mt-2 pl-3 pr-3'>
              <Form.Group controlId='SelectCustomFormHidden'>
                <Form.Group controlId='StartTimeForm'>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type='date'
                    value={StartDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                    className='border'
                  />
                  <Form.Text className='text-muted'>The date sessions start on.</Form.Text>
                </Form.Group>
              </Form.Group>
            </Col>

            <Col sm='4' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='SelectCustomForm'>
                <Form.Label>Day of Session</Form.Label>
                <Form.Control
                  as='select'
                  value={Day}
                  onChange={(e) => setDay(e.target.value)}
                  required
                  custom
                  className='border'
                >
                  <option value='' disabled defaultValue>
                    Select your option
                  </option>
                  <option value='Monday'>Monday</option>
                  <option value='Tuesday'>Tuesday</option>
                  <option value='Wednesday'>Wednesday</option>
                  <option value='Thursday'>Thursday</option>
                  <option value='Friday'>Friday</option>
                  <option value='Saturday'>Saturday</option>
                  <option value='Sunday'>Sunday</option>
                </Form.Control>
                <Form.Text className='text-muted'>The day the session will be held.</Form.Text>
              </Form.Group>
            </Col>

            <Col sm='4' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='StartTimeForm'>
                <Form.Label>Start Time</Form.Label>
                <Form.Control
                  type='time'
                  value={StartTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  required
                  className='border'
                />
                <Form.Text className='text-muted'>The start time of the session.</Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm='4' className='mt-2  pl-3 pr-3'>
              <Form.Group className='pr-4' controlId='EndTimeForm'>
                <Form.Label>Ending Time</Form.Label>
                <Form.Control
                  type='time'
                  value={FinishTime}
                  onChange={(e) => setFinishTime(e.target.value)}
                  required
                  className='border'
                />
                <Form.Text className='text-muted'>The end time of the session.</Form.Text>
              </Form.Group>
            </Col>
            <Col sm='4' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='CapacityForm'>
                <Form.Label>Capacity</Form.Label>
                <Form.Control
                  type='number'
                  min='0'
                  max='100'
                  value={MaxLearners}
                  onChange={(e) => setMaxLearners(e.target.value)}
                  required
                  className='border'
                />
                <Form.Text className='text-muted'>
                  The maximum number of participants for this session.
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm='4' className='mt-2  pl-3 pr-3'>
              <Form.Group controlId='PriceForm'>
                <Form.Label>Price / Month</Form.Label>
                <Form.Control
                  type='number'
                  min='0'
                  max='1000'
                  step='0.01'
                  placeholder='10.50'
                  value={Price}
                  onChange={(e) => setPrice(e.target.value)}
                  required
                  className='border'
                />
                <Form.Text className='text-muted'>
                  The monthly price to be rendered in your currency.
                </Form.Text>
              </Form.Group>
            </Col>
            <hr/>
          </Row>
          <Row className="mt-3">
            <Col className='mt-2 text-center'>
              <Button
                className='mb-3'
                variant='primary'
                size='lg'
                type='submit'
                disabled={submitClicked}
              >
                Create Regular Booking
              </Button>
            </Col>
          </Row>
        </Form>
      </FadeIn>
    </Row>
  );
};

export default CreateClassForm;
